import { render, staticRenderFns } from "./WarwickshirePolice.vue?vue&type=template&id=1a5b4471&scoped=true"
import script from "./WarwickshirePolice.vue?vue&type=script&lang=js"
export * from "./WarwickshirePolice.vue?vue&type=script&lang=js"
import style0 from "./WarwickshirePolice.vue?vue&type=style&index=0&id=1a5b4471&prod&scoped=true&lang=css"
import style1 from "./WarwickshirePolice.vue?vue&type=style&index=1&id=1a5b4471&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5b4471",
  null
  
)

export default component.exports